<template>
    <div v-if="visible" class="popup-overlay" @click.stop="closePopup">
        <div class="popup-container" @click.stop="">
            <button @click="closePopup" class="close-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path
                        d="M12 10.586l6.364-6.364 1.414 1.414-6.364 6.364 6.364 6.364-1.414 1.414-6.364-6.364-6.364 6.364-1.414-1.414 6.364-6.364-6.364-6.364 1.414-1.414z"
                    />
                </svg>
            </button>
            <h2>授权区别</h2>
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th class="name">授权范围</th>
                            <th class="item">个人授权</th>
                            <th class="item">商用授权</th>
                            <th class="item" v-if="showPlus">商用PLUS授权</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in tableData" :key="index">
                            <td class="name">{{ item.content }}</td>
                            <td class="item">
                                <div v-if="item.selected[0] !== undefined">
                                    <img src="../../assets/images/auth-pass.svg" v-if="item.selected[0] === 0" alt="" />
                                    <img src="../../assets/images/auth-reject.svg" v-else alt="" />
                                </div>
                                <div v-else>-</div>
                            </td>
                            <td class="item">
                                <div v-if="item.selected[1] !== undefined">
                                    <img src="../../assets/images/auth-pass.svg" v-if="item.selected[1] === 0" alt="" />
                                    <img src="../../assets/images/auth-reject.svg" v-else alt="" />
                                </div>
                                <div v-else>-</div>
                            </td>
                            <td class="item" v-if="showPlus">
                                <div v-if="item.selected[2] !== undefined">
                                    <img src="../../assets/images/auth-pass.svg" v-if="item.selected[2] === 0" alt="" />
                                    <img src="../../assets/images/auth-reject.svg" v-else alt="" />
                                </div>
                                <div v-else>-</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tip">*请根据使用主体和使用范围选择匹配的授权，若超出范围使用可能会损害您的权益</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        tableData: {
            type: Array,
            required: true,
        },
        showPlus: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        closePopup() {
            this.$emit('update:visible', false);
        },
    },
};
</script>
<style scoped lang="scss">
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.popup-container {
    background: #ffffff;
    padding: 30px 45px 45px 45px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 1100px;
    width: 100%;
    position: relative;
    overflow-y: hidden;
    max-height: 90%;
    display: flex;
    flex-direction: column;
}
h2 {
    font-size: 26px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 30px;
    text-align: center;
}
.table-container {
    flex: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 0; /* 或者设置为不显示 */
        height: 0;
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    // margin-bottom: 20px;
}
thead tr th {
    background: #f9f9f9;
    border: 0;
    &:nth-child(1) {
        border-radius: 10px 0 0 10px;
    }
    &:nth-last-child(1) {
        border-radius: 0 10px 10px 0;
    }
}
th,
td {
    height: 54px;
    padding: 0 29px;
    text-align: left;
    font-size: 14px;
    border-bottom: 1px solid #ededed;
}
th {
    position: sticky;
    top: 0;
    background-color: #f1f1f1;
    z-index: 1; /* 确保表头在内容上方 */
    color: #000000;
    font-weight: bold;
}
tr {
    &:hover {
    
        td {
            background: #f9f9f9;
        }
    }
}
td {
    background-color: #ffffff;
    color: #555555;
}
td svg {
    width: 18px;
    height: 18px;
}
td svg:nth-child(1) {
    fill: #4caf50; /* 绿色 */
}
td svg:nth-child(2) {
    fill: #f44336; /* 红色 */
}
.item {
    text-align: center;
    div {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9e9e9e;
    }
    img {
        width: 17px;
        height:17px;
    }
}
.name {
    color: #000;
}

.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    cursor: pointer;
}
.close-btn svg {
    width: 20px;
    height: 20px;
    fill: #888888;
}
.tip {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
    margin-top: 30px;
}
</style>
